import KeenSlider from 'keen-slider'

document.addEventListener('DOMContentLoaded', () => {
	const portfolio = document.querySelector('.portfolio-slider')
	const sliderContainer = portfolio.querySelector('.keen-slider')

	let currentTime = Date.now()
	let newTime
	let timeout
	let mainTime
	let mouseOver = false
	function clearNextTimeout() {
		clearTimeout(timeout)
	}

	function nextTimeout(instance, delay = 0) {
		// clearTimeout(timeout)
		// if (mouseOver) return
		// mainTime = mainTime - delay
		// timeout = setTimeout(() => {
		// 	instance.next()
		// }, Math.max(mainTime, 0))
	}
	let lastSlide = null
	let initialDelay = true // Delay first animation to avoid CLS
	let slider = new KeenSlider(sliderContainer, {
		loop: true,
		slides: {
			origin: 'center',
			perView: 1.3,
			spacing: 24,
		},
		breakpoints: {
			'(min-width:512px)': {
				slides: {
					origin: 'center',
					perView: 1.3,
					spacing: 24,
				},
			},
			'(min-width:768px)': {
				slides: {
					origin: 'center',
					perView: 2.1,
					spacing: 24,
				},
			},
			'(min-width:1536px)': {
				slides: {
					origin: 'center',
					perView: 2.3,
					spacing: 24,
				},
			},
			'(min-width:1920px)': {
				slides: {
					origin: 'center',
					perView: 2.7,
					spacing: 24,
				},
			},
		},
		created(instance) {
			mainTime = 5000
			instance.slides[0].classList.add('active')
			lastSlide = instance.slides[0]
			const slides = sliderContainer.querySelectorAll('.keen-slider__slide img')
			slides.forEach(slide => {
				slide.addEventListener('mouseover', () => {
					mouseOver = true
					currentTime = Date.now()
					clearNextTimeout()
				})
				slide.addEventListener('mouseout', () => {
					mouseOver = false
					newTime = Date.now() - currentTime
					currentTime = Date.now()
					nextTimeout(instance, newTime)
				})
			})
		},
		slideChanged() {
			mainTime = 5000
			const currentSlideIndex = slider.track.details.rel
			const currentSlide = slider.slides[currentSlideIndex]
			if (lastSlide) {
				lastSlide.classList.remove('active')
			}
			currentSlide.classList.add('active')
			lastSlide = currentSlide
		},

		dragStarted: clearNextTimeout,
		animationEnded(instance) {
			if (!initialDelay) nextTimeout(instance)
		},
		updated(instance) {
			if (!initialDelay) nextTimeout(instance)
		},
	})
	// Start autoplay after 3s to avoid CLS during page load
	setTimeout(() => {
		initialDelay = false
		nextTimeout(slider)
	}, 3000)
	setTimeout(() => {
		slider.update()
	}, 1000)
	const slides = sliderContainer.querySelectorAll('.keen-slider__slide')
	slides.forEach(slide => {
		const img = slide.querySelector('img')
		img.style.transition =
			'all var(--transition-duration) var(--transition-timing-function)'
	})
})
